import script from "./FamilyGroupInviteAcceptPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FamilyGroupInviteAcceptPage.vue?vue&type=script&setup=true&lang=ts"

import "./FamilyGroupInviteAcceptPage.vue?vue&type=style&index=0&id=0dfaad5c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dfaad5c"]])

export default __exports__